import { CmsDataUrl, GoogleTagConfig } from '@common/util-models';
import { ComponentMapping } from './component-mapping.type';

export interface AppProvidersConfig {
  componentMapping: ComponentMapping;
  gaTagsConfig: GoogleTagConfig;
  cmsDataUrl: CmsDataUrl;
  googleTagGlobalProps?: Record<string, string>;
}
